import BaseModel from './BaseModel';

class PageModel extends BaseModel {
    constructor(json) {
        if (!json) json = { content: [], pageable: { total: 0, page: 1 }, direction: 'desc' };
        super(json, {});
    }

    get content() {
        return this.getPayload().content;
    }

    get pageable() {
        return this.getPayload().pageable;
    }

    set content(value) {
        this.getPayload().content = value;
    }

    set pageable(value) {
        this.getPayload().pageable = value;
    }

    get isMore() {
        return this.getPayload().pageable.total > this.getPayload().content.length;
    }

    get total() {
        return this.getPayload().pageable.total;
    }
    get page() {
        return this.getPayload().pageable.page || 1;
    }

    get totalPage() {
        return this.getPayload().pageable.totalPage || 1;
    }

    get rows() {
        return this.getPayload().pageable.rows;
    }

    get direction() {
        return this.getPayload().direction;
    }

    set direction(value) {
        this.getPayload().direction = value;
    }

    set total(value) {
        this.getPayload().pageable.total = value;
    }

    set page(value) {
        this.getPayload().pageable.page = value;
    }

    set rows(value) {
        this.getPayload().pageable.rows = value;
    }
    bindPage(response) {
        response.pageable.page++;
        this.getPayload().pageable = response.pageable;
    }
    bind(response, isAdd) {
        if (isAdd) this.getPayload().content.push(...response.content);
        else this.getPayload().content = response.content;
        this.getPayload().pageable = response.pageable;
    }
    addPage() {
        var page = this.getPayload().pageable.page || 1;
        this.getPayload().pageable.page = page + 1;
    }
    query() {
        return {
            page: this.getPayload().pageable.page || 1,
            rows: this.getPayload().pageable.rows || 20,
            direction: this.getPayload().direction || 'desc'
        };
    }
    addItem(content) {
        this.getPayload().content.unshift(content);
        const total = this.getPayload().pageable.total;
        this.getPayload().pageable.total = total - 1;
    }
    removeItem(id) {
        const fnCondition = item => item.id === id;
        const idx = this.getPayload().content.findIndex(fnCondition);
        const total = this.getPayload().pageable.total;
        this.getPayload().pageable.total = total - 1;
        this.getPayload().content.splice(idx, 1);
    }
    isLast() {
        return this.getPayload().pageable.page >= this.getPayload().pageable.totalPage;
    }
}

export default PageModel;
